module.exports = __webpack_public_path__ + "static/img/profile-icon13.da61ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon13.png
// module id = 2961
// module chunks = 1